import { render, staticRenderFns } from "./ModelLinkModal.vue?vue&type=template&id=140dd3a4&"
import script from "./ModelLinkModal.vue?vue&type=script&lang=js&"
export * from "./ModelLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./ModelLinkModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports